import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginRenderingService } from '../login/login-rendering.service';
import { LoginDTO } from 'src/app/models/login/loginDetails';
import { BorrowerRenderingService } from '../borrower/borrower-rendering.service';

@Injectable({
  providedIn: 'root'
})
export class DLPRestUtilityService {

  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  });

  

  options = {
    headers: this.httpHeaders
  };

  constructor(private http: HttpClient, private loginService: LoginRenderingService,
    private borrowerRenderingService: BorrowerRenderingService) {
  }
  // createAuthorizationHeader(headers:HttpHeaders) {

  //   headers.append('Authorization',
  //   'Basic ' +

  //   btoa('a20e6aca-ee83-44bc-8033-b41f3078c2b6:c199f9c8-0548-4be79655-7ef7d7bf9d20'));

  //   }

  // saveBorrower(borrower: any): Observable<any> {

  //   let httpHeaders = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Cache-Control': 'no-cache'
  //   });

  // this.createAuthorizationHeader(httpHeaders);


  saveBorrower(borrower: any, edit: boolean): Observable<any> {
    let url: string = environment.apiURL.saveInfo;

    // console.log(JSON.stringify("client ==== "+JSON.stringify(borrower)));
    if (!edit) {
      return this.http.post(url, borrower, this.options);
    }
    else {
      return this.http.put(url, borrower, this.options);
    }
  }

  deleteBorrower(borrower: any): Observable<any> {
    let options = {
      headers: this.httpHeaders,
      observe: "response" as 'body',
      body: borrower
    }
    let url: string = environment.apiURL.saveInfo;
    return this.http.delete(url, options);
  }

  saveIncomeBorrower(incomeBorrower: any): Observable<any> {
    let url: string = environment.apiURL.saveIncome;
    return this.http.post(url, incomeBorrower, this.options);
  }

  // saveLoanBorrower(loanBorrower: any): Observable<any> {
  //   let url: string = environment.apiURL.saveLoan;
  //   return this.http.post(url, loanBorrower, this.options);
  // }

  // fetchFinancialProductDetails(): Observable<any> {
  //   //let url: string = environment.apiURL.financialProductDetails;
  //   let url: string = "../../../../assets/restJSON/loanDetailsWithRepay.json";
  //   return this.http.get(url, this.options);
  // }

  onQuoteCreation(newQuote: any): Observable<any> {
    let url: string = environment.apiURL.quoteCreation;
    return this.http.post(url, newQuote, this.options);

    // let result = "../../../../assets/restJSON/quoteCreation.json";
    // return this.http.get(result);
  }

  onQuoteUpdation(newQuote: any): Observable<any> {
    let url: string = environment.apiURL.quoteUpdation;
    return this.http.put(url, newQuote, this.options);

    // let result = "../../../../assets/restJSON/quoteCreation.json";
    // return this.http.get(result);
  }

  fetchDlrUsr(data: any): Observable<any> {
    let url: string = environment.apiURL.usrDlrMap;
    return this.http.post(url, data, this.options);

    // let result = "../../../../assets/restJSON/quoteCreation.json";
    // return this.http.get(result);
  }

  onGenerateOTP(OTP: any): Observable<any> {
    let url: string = environment.apiURL.generateOtp;
    return this.http.post(url, OTP, this.options);
  }

  sendOtp(OTP: any) {
    let url: string = environment.apiURL.sendOtp;
    // to be reviewed
    return this.http.post(url, OTP, this.options);
  }

  resendOtp(OTP: any): Observable<any> {
    let url: string = environment.apiURL.resendOtp;
    // to be reviewed
    return this.http.post(url, OTP, this.options);
  }


  onGenerateOTPToVeifyEmailMobile(OTP: any): Observable<any> {
    let url: string = environment.apiURL.generateOtpToVerifyMobileEmail;
    return this.http.post(url, OTP, this.options);
  }

  sendOtpToVeifyEmailMobile(OTP: any) {
    let url: string = environment.apiURL.sendOtpToVerifyMobileEmail;
    // to be reviewed
    return this.http.post(url, OTP, this.options);
  }

  resendOtpToVeifyEmailMobile(OTP: any): Observable<any> {
    let url: string = environment.apiURL.resendOtpToVerifyMobileEmail;
    // to be reviewed
    return this.http.post(url, OTP, this.options);
  }

  onSearchQuote(searchQuote: any): Observable<any> {
    let url: string = environment.apiURL.searchQuote;
    return this.http.post(url, searchQuote, this.options);
  }

  onTrackQuote(trackQuote: any): Observable<any> {
    let url: string = environment.apiURL.trackQuote;
    return this.http.post(url, trackQuote, this.options);
  }

  onApprovalStatusList(approvalList: any): Observable<any> {
    let url: string = environment.apiURL.approvalList;
    return this.http.post(url, approvalList, this.options);
    // let url: string = "../../../../assets/restJSON/approvalStatus.json";
    // return this.http.get(url, this.options);
  }

  fetchVehicleDetails(value): Observable<any> {
    //alert("fetchVehicleDetailsfetchVehicleDetails");
    // let user: LoginDTO = JSON.parse(localStorage.getItem('currentUser'));
    let user: LoginDTO=this.loginService.currentUser;

    let url: string;
    if (user) {
      let id = user.userId;
      url = environment.apiURL.fetchVehicleDetails + value + "/" + id;
    }
    else {
      url = environment.apiURL.fetchVehicleDetails + value + "/" + 'BA2A';
    }

    if (value === "used") {
      url = environment.apiURL.fetchVehicleDetails + value;
    }
    // let url: string = "../../../../assets/restJSON/usedQuote.json";
    // let url: string = "../../../../assets/restJSON/newQoute.json";
    return this.http.get(url, this.options);
  }

  fetchQuotationStatus(): Observable<any> {
    let url: string = environment.apiURL.fetchQuotationStatus;
    //let url: string = "../../../../assets/restJSON/quotationStatus.json";
    return this.http.get(url, this.options);
  }

  onLogin(Login: any): Observable<any> {
    let url: string = environment.apiURL.login;
    return this.http.post(url, Login, { observe: 'response' });
    // let url: string = "../../../../assets/restJSON/login.json";
    // return this.http.get(url, this.options);
  }

  fetchBackFormDetails(previousFormType: string, portfolioID: any, id: string): Observable<any> {
    let url: string = environment.apiURL.fetchBackForm + previousFormType + '/' + portfolioID + '/' + id;
    //let url: string = "../../../../assets/restJSON/primary.json";
    return this.http.get(url, this.options);
  }

  // fetchSubvention(previousFormType: string, portfolioID: number, quotationId: any): Observable<any> {
  //   let url: string = environment.apiURL.getSubvention + previousFormType + '/' + portfolioID + '/' + quotationId;
  //   return this.http.get(url, this.options);
  // }

  fetchCurrentAddressDetailsFromPincode(pincode: any): Observable<any> {
    let url: string = environment.apiURL.addressDetails;
    //let url= "http://10.203.46.140:8080/nrfsi/nissan/locality/pincode";
    //let url: string = "../../../../assets/restJSON/newAdress.json";
    return this.http.post(url, pincode, this.options);
    //return this.http.get(url, this.options);
  }

  fetchSzOrgTypeData(json:any): Observable<any> {
    let url: string = environment.apiURL.fetchSzOrgTypeData;
    //let url= "http://10.203.46.140:8080/nrfsi/nissan/locality/pincode";
    //let url: string = "../../../../assets/restJSON/newAdress.json";
    return this.http.post(url, json, this.options);
    //return this.http.get(url, this.options);
  }

  fetchAllStates(): Observable<any> {
    let url: string = environment.apiURL.states;
    //let url= "http://10.203.46.140:8080/nrfsi/nissan/locality/pincode";
    //let url: string = "../../../../assets/restJSON/newAdress.json";
    return this.http.get(url, this.options);
    //return this.http.get(url, this.options);
  }

  fetchCitiesByState(value : any): Observable<any> {
    let url: string = environment.apiURL.cities+'/'+value+ '/' + 'nissan_dlp';
    //let url= "http://10.203.46.140:8080/nrfsi/nissan/locality/pincode";
    //let url: string = "../../../../assets/restJSON/newAdress.json";
    return this.http.get(url, this.options);
    //return this.http.get(url, this.options);
  }

  fetchDealerByCity(dealer: any): Observable<any> {
    let url: string = environment.apiURL.cityDealers;
    //let url= "http://10.203.46.140:8080/nrfsi/nissan/locality/pincode";
    //let url: string = "../../../../assets/restJSON/newAdress.json";
    return this.http.post(url, dealer, this.options);
    //return this.http.get(url, this.options);
  }

  fetchDropDown(): Observable<any> {
    let url: string = environment.apiURL.dropdown + "/1";
    //let url: string = "../../../../assets/restJSON/dropdown.json";
    return this.http.get(url, this.options);
  }

  fetchFinancialProduct(parameter): Observable<any> {
    let url: string = environment.apiURL.financialProduct;
    //let url: string = "../../../../assets/restJSON/financialProduct.json";

    //let url: string = "../../../../assets/restJSON/subproducts.json";
    return this.http.post(url, parameter, this.options);
    // return this.http.get(url, this.options)
  }

  fetchSpecialProgram(parameter): Observable<any> {
    let url: string = environment.apiURL.specialProgram;
    //  let url: string = "../../../../assets/restJSON/financialProduct.json";
    // console.log(parameter);
    return this.http.post(url, parameter, this.options);
    // return this.http.get(url, this.options)
  }

  saveStep1(step1): Observable<any> {
    let url: string = environment.apiURL.loanStep1Post;
    //let url: string = "../../../../assets/restJSON/FinProdLoanDto.json"
    return this.http.post(url, step1, this.options);
    // return this.http.get(url, this.options)
  }

  refId(step2): Observable<any> {
    // let options = {
    //   headers: this.httpHeaders,
    //   observe: "response" as 'body',
    // }
    let url: string = environment.apiURL.refId;
    //  let url: string = "../../../../assets/restJSON/FinProdLoanDto.json"
    return this.http.post(url, step2, this.options);
    //return this.http.get(url, this.options)
  }

  saveStep2(step2): Observable<any> {
    // let options = {
    //   headers: this.httpHeaders,
    //   observe: "response" as 'body',
    // }
    let url: string = environment.apiURL.loanStep2Post;
    //  let url: string = "../../../../assets/restJSON/FinProdLoanDto.json"
    return this.http.post(url, step2, this.options);
    //return this.http.get(url, this.options)
  }

  getEmi(emi): Observable<any> {
    // let options = {
    //   headers: this.httpHeaders,
    //   observe: "response" as 'body',
    // }
    let url: string = environment.apiURL.emi;
    //  let url: string = "../../../../assets/restJSON/FinProdLoanDto.json"
    return this.http.post(url, emi, this.options);
  }

  subvention(subvention: any): Observable<any> {
    let url: string = environment.apiURL.subvention;
    // console.log('', url);
    // console.log('', subvention);
    // let url: string = "../../../../assets/restJSON/master.json";
    return this.http.post(url, subvention, this.options);
  }


  getSubvention(subvention: any): Observable<any> {
    let url: string = environment.apiURL.getSubventionDetails;
    //let url: string = "../../../../assets/restJSON/master.json";
    return this.http.post(url, subvention, this.options);
  }


  subventionEmi(subventionEmi): Observable<any> {
    let url: string = environment.apiURL.subventionEmi;
    //  let url: string = "../../../../assets/restJSON/FinProdLoanDto.json"
    return this.http.post(url, subventionEmi, this.options);
  }

  subProdSave(subProduct: any): Observable<any> {
    let url: string = environment.apiURL.subproducts;
    //let url: string = "../../../../assets/restJSON/master.json";
    return this.http.post(url, subProduct, this.options);
  }

  subProdEmi(subProduct: any): Observable<any> {
    let url: string = environment.apiURL.subproductsEmi;
    //let url: string = "../../../../assets/restJSON/master.json";
    return this.http.post(url, subProduct, this.options);
  }



  onChangeCreation(newQuote: any): Observable<any> {
    let url: string = environment.apiURL.changeCreation;
    return this.http.put(url, newQuote, this.options);

    // let result = "../../../../assets/restJSON/quoteCreation.json";
    // return this.http.get(result);
  }

  loanReset(loanReset: any): Observable<any> {
    let options = {
      headers: this.httpHeaders,
      observe: "response" as 'body',
      body: loanReset
    }
    let url: string = environment.apiURL.loanReset;
    return this.http.delete(url, options);
  }


  preview(portfolioId: number, quotationId: string, custid: string): Observable<any> {
    let url: string = environment.apiURL.preview + portfolioId + "/" + quotationId + "/" + custid;
    // console.log(url);
    //let url: string = "../../../../assets/restJSON/preview.json";
    return this.http.get(url, this.options);
  }

  trackQoute(applicationNo): Observable<any> {
    let url: string = environment.apiURL.trackQuote;
    let body = {
      "applicationNo": applicationNo
    };
    //let url: string = "../../../../assets/restJSON/trackApplication.json";

    return this.http.post(url, body, this.options);
  }


  recentActivities(): Observable<any> {
    let url: string = environment.apiURL.recentActivities;

   // let url: string = "../../../../assets/restJSON/dropdown.json";
    return this.http.get(url, this.options);
  }

  notification(): Observable<any> {
   let url: string = environment.apiURL.notification;
   //let url: string = "../../../../assets/restJSON/notify.json";
    return this.http.get(url, this.options);
  }

  deleteNotification(deleteNotification: any): Observable<any> {
    let url: string = environment.apiURL.deleteNotifiaction;
    //let url: string = "../../../../assets/restJSON/notify.json";
    return this.http.post(url,deleteNotification ,deleteNotification);
  }

  broadcastnotification(): Observable<any> {
    //let url: string = environment.apiURL.broadcastnotification;
    let url: string = "../../../../assets/restJSON/broadcastNotify.json";
   return this.http.get(url, this.options);
   }

   deleteBroadcastNotification(deleteBroadcastNotification: any): Observable<any> {
    //let url: string = environment.apiURL.deleteNotifiaction;
    let url: string = "../../../../assets/restJSON/broadcastNotify.json";
    return this.http.post(url,deleteBroadcastNotification ,deleteBroadcastNotification);
  }

  getFinanceDescription(portfolioId, quotationId) {
    //let url: string = "../../../../assets/restJSON/getProductDescription.json";
    let url: string = environment.apiURL.getFinanceDescription + "/" + portfolioId + "/" + quotationId;
    return this.http.get(url, this.options);
  }

  trackDistinct(searchQuote: any): Observable<any> {
    let url: string = environment.apiURL.trackDistinct;
    return this.http.post(url, searchQuote, this.options);
  }
  loginNew(){
    let url: string = environment.apiURL.login;

      var login =JSON.stringify({ userId: "nissan_dlp",
         password: "RAmji2@26"});
    
    var xmlHttpRequest = new XMLHttpRequest();
    try {
    xmlHttpRequest.open('POST', url,false);
    xmlHttpRequest.setRequestHeader('Content-type', 'application/json; charset=utf-8');
 
    xmlHttpRequest.send(login);
        if (xmlHttpRequest.status != 200) {
          console.log(`Error ${xmlHttpRequest.status}: ${xmlHttpRequest.statusText}`);
        } else {
          return xmlHttpRequest;
          xmlHttpRequest;
        }
      } catch(err) { // instead of onerror
        alert("Request failed"+JSON.stringify(err));
      }
   
      return xmlHttpRequest;
 }

   dropdownNew(){
  
   // alert('0000000000000000dropdownNew');
    //var url = 'http://localhost:8080/nrfsi/nissan/applicant/autofill/1';
    let url: string = environment.apiURL.dropdown + "/1";
    var xmlHttpRequest = new XMLHttpRequest();
    try {
    xmlHttpRequest.open('GET', url,false);
    xmlHttpRequest.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let currentUser=this.loginService.currentUser;

    var jwtoken =currentUser.token;
    xmlHttpRequest.setRequestHeader('X-AUTH-TOKEN', 'Bearer ' + jwtoken);
    //xmlHttpRequest.responseType = 'json';
    xmlHttpRequest.send();
        if (xmlHttpRequest.status != 200) {
          console.log(`Error ${xmlHttpRequest.status}: ${xmlHttpRequest.statusText}`);
        } else {
          localStorage.removeItem(url);
          localStorage.setItem(url, xmlHttpRequest.response);
 
          return xmlHttpRequest;
        }
      } catch(err) { // instead of onerror
        alert("Request failed"+JSON.stringify(err));
      }
   return xmlHttpRequest;
   
 }
 
 upload(file: File[], data: any) :Promise<any>{
    return new Promise((resolve, reject) => {
      const formData: FormData = new FormData();
      let url: string = environment.apiURL.docsUpload;
      for (let i = 0; i < file.length; i++) {
        formData.append('file', file[i]);
      }
      formData.append('docsDetails', JSON.stringify(data));
      this.http.post(url, formData).toPromise().then(res=>{
        resolve(res);
      }).catch((err) => { 
        reject(err); // Here.
       
    });
  });


    

    

  }

  validatePAN(panDto: any): Observable<any> {
    let url: string = environment.apiURL.validatePAN;
    return this.http.post(url, panDto, this.options);
  }

}

